(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // 2.9 Quantity change → POST new quantity to /cart/update.json then reload
    // so Liquid re-calculates weight with the correct new quantities.
    function updateCartAndReload() {
      var inputs = document.querySelectorAll('.ps-cart__qty-input');
      var updates = {};
      inputs.forEach(function (input) {
        var row = input.closest('[data-cart-item-key]');
        if (row) {
          updates[row.getAttribute('data-cart-item-key')] = parseInt(input.value, 10) || 0;
        }
      });
      fetch('/cart/update.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        location.reload(true);
      }).catch(function () {
        location.reload(true);
      });
    }

    var qtyInputs = document.querySelectorAll('.ps-cart__qty-input');
    qtyInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateCartAndReload();
      });
    });

    // Intercept Update button submit → POST via fetch + reload for fresh weight
    var cartForm = document.querySelector('.ps-cart__form');
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name === 'update') {
          e.preventDefault();
          updateCartAndReload();
        }
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.ps-faq__item');
        var answer = item.querySelector('.ps-faq__answer');
        var isOpen = item.classList.contains('ps-faq__item--open');
        if (isOpen) {
          item.classList.remove('ps-faq__item--open');
          answer.hidden = true;
          this.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('ps-faq__item--open');
          answer.hidden = false;
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solution-review"] && !Shopify.designMode) return;
  try {
    
  // Load the standalone solution-builder.js asset.
  // The URL is stored in a data attribute to avoid Liquid inside JS (unsupported).
  // Guard on the section element ensures this only runs on solution-review pages.
  (function () {
    var reviewEl = document.getElementById('ps-solution-review');
    if (!reviewEl) return;
    if (window.__psSolutionBuilderLoaded) return;
    window.__psSolutionBuilderLoaded = true;
    var s = document.createElement('script');
    s.src = reviewEl.dataset.solutionBuilderUrl || '';
    s.defer = true;
    document.head.appendChild(s);
  })();

  } catch(e) { console.error(e); }
})();
})();
